class CommerceGrid {
    constructor() {
        this.pendingXHR = undefined;
        this.init();
    }

    init() {
        const grids = document.querySelectorAll('.commerce-grid');
        this.initGrids(grids, this);
    }

    initGrids(grids, scope) {
        for (let i = 0; i < grids.length; i++) {
            const grid = grids[i];
            const rows = grid.querySelectorAll('.commerce-grid-row');
            const form = grid.querySelector('form');
            const bottomToolbarItems = grid.querySelectorAll('.commerce-grid-toolbar-item-bottom');
            const topToolbar = grid.querySelector('.commerce-grid-toolbar');
            const bottomToolbar = grid.querySelector('.commerce-grid-bottom-toolbar');

            // Prepare grid rows with listeners
            this.prepareGridRows(rows);

            for (let i = 0; i < bottomToolbarItems.length; i++) {
                const bottomToolbarItem = bottomToolbarItems[i];
                const btmItemInput = bottomToolbarItem.querySelector('input');
                const replacement = document.createElement('input');

                bottomToolbar.appendChild(bottomToolbarItem);

                replacement.setAttribute('type', 'hidden');
                replacement.setAttribute('name', btmItemInput.getAttribute('name'));
                replacement.setAttribute('value', btmItemInput.value);
                replacement.setAttribute('id', `${btmItemInput.getAttribute('id')}-replacement`);
                topToolbar.insertBefore(replacement, topToolbar.firstChild);

                let debounce;
                btmItemInput.addEventListener('input', (e) => {
                    replacement.value = btmItemInput.value;
                    // Delay request to allow for multiple keystrokes
                    if (debounce) {
                        clearTimeout(debounce);
                    }
                    debounce = setTimeout(() => {
                        scope.submitToolbarForm(grid.querySelector('form'));
                    }, 500);

                    // replacement.dispatchEvent(new Event('change')); // not sure if this is necesary, i think setting the value above may trigger this - jp
                });
            } // end for bottomToolbarItems

            let btmToolbarForm = bottomToolbar.closest('form');
            if (btmToolbarForm) {
                btmToolbarForm.addEventListener('submit', (event) => {
                    event.preventDefault();
                    scope.submitToolbarForm(grid.querySelector('form'));
                });
            }


            const gridSortFld = document.createElement('input');
            gridSortFld.setAttribute('type', 'hidden');
            gridSortFld.setAttribute('name', form.getAttribute('data-widget') + "[sortby]");
            topToolbar.insertBefore(gridSortFld, topToolbar.firstChild);
            const gridSortDirFld = document.createElement('input');
            gridSortDirFld.setAttribute('type', 'hidden');
            gridSortDirFld.setAttribute('name', form.getAttribute('data-widget') + "[sortdir]");
            topToolbar.insertBefore(gridSortDirFld, topToolbar.firstChild);


            const sortFields = grid.querySelectorAll('.commerce-grid-sortby');
            for (let j = 0; j < sortFields.length; j++) {
                let sortField = sortFields[j];

                sortField.addEventListener('change', () => {
                    gridSortFld.value = sortField.value;
                    scope.submitToolbarForm(form);
                });
            }
            const sortDirFields = grid.querySelectorAll('.commerce-grid-sortdir');
            for (let j = 0; j < sortDirFields.length; j++) {
                let sortDirField = sortDirFields[j];

                sortDirField.addEventListener('change', () => {
                    gridSortDirFld.value = sortDirField.value;
                    scope.submitToolbarForm(form);
                });
            }
        }

        // Watch out for changes to any of the filters in the grid toolbar
        for (let i = 0; i < grids.length; i++) {
            const grid = grids[i];
            grid.addEventListener('change', handleGridInputChange);
            grid.addEventListener('input', handleGridInputChange);
            grid.addEventListener('click', function (event) {
                if (event.target.matches('.commerce-grid-pagination a') || event.target.matches('.commerce-grid-pagination a i')) {
                    if (event.ctrlKey || event.metaKey) {
                        return true;
                    }

                    event.preventDefault();

                    let pageNum = event.target.getAttribute('data-page') || event.target.parentNode.getAttribute('data-page');
                    if (pageNum) {
                        grid.querySelector('.commerce-grid-page-input').value = pageNum;
                        scope.submitToolbarForm(grid.querySelector('form'));
                    }
                    return false;
                }
            });
        }

        function handleGridInputChange(event) {
            if (event.target.matches('.commerce-grid-toolbar input, .commerce-grid-toolbar select')) {
                const input = event.target;
                let form = input.closest('form');
                scope.submitToolbarForm(form);
            }
        }
    }

    /**
     * Allows for listeners to be applied to rows in the grid.
     * This is called during grid initialization, and for xhr responses.
     * @param rows
     */
    prepareGridRows(rows) {
        for (let i = 0; i < rows.length; i++) {
            // Adds a .commerce-grid-row-selected class when a selector checkbox is checked
            const checkbox = rows[i].querySelector('.commerce-grid-checkbox');
            if (checkbox) {
                checkbox.addEventListener('change', (e) => {
                    const className = 'commerce-grid-row-selected';
                    if (checkbox.checked) {
                        rows[i].classList.add(className);
                    } else {
                        rows[i].classList.remove(className);
                    }
                });
            }

            // Add other listeners here...
        }
    }

    submitToolbarForm(form) {
        const valueString = (function () {
            const params = [];
            for (let i = 0; i < form.elements.length; i++) {
                let e = form.elements[i];
                params.push(encodeURIComponent(e.name) + "=" + encodeURIComponent(e.value));
            }
            return params.join('&');
        })();

        const grid = form.closest('.commerce-grid');
        const rowContainer = grid.querySelector('.commerce-grid-row-container');

        rowContainer.classList.add('commerce-grid-loading');

        let that = this;
        new Promise(function (resolve, reject) {
            function reqListener() {
                resolve(this.responseText);
            }

            function reqError(err) {
                reject(err);
            }

            let oReq = new XMLHttpRequest();
            oReq.onload = reqListener;
            oReq.onerror = reqError;

            let url = form.getAttribute('action') || window.location.href;
            oReq.open('get', `${url}&${valueString}`, true);
            oReq.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            oReq.send();

            that.pendingXHR = oReq;
        }).then((response) => {
            that.pendingXHR = false;

            // Remove old rows
            const oldRows = rowContainer.querySelectorAll('.commerce-grid-row');
            for (let i = 0; i < oldRows.length; i++) oldRows[i].remove();

            // Remove loading mask
            rowContainer.classList.remove('commerce-grid-loading');

            // Parse the response
            const vdom = new DOMParser().parseFromString(response, "text/html");
            const newRows = vdom.querySelectorAll('.commerce-grid-row');
            if (newRows.length > 0) {
                // Prepare the new rows being inserted into the grid
                that.prepareGridRows(newRows);

                // Insert the rows
                for (let i = 0; i < newRows.length; i++) rowContainer.appendChild(newRows[i]);

                const paginationContainer = grid.querySelector('.commerce-grid-pagination');
                paginationContainer.innerHTML = vdom.querySelector('.commerce-grid-pagination').innerHTML;

                const gridFooter = grid.querySelector('.commerce-grid-footer');
                // Unsure as to what the purpose of this is. Commenting out prevents the limit field disappearing.
                //gridFooter.innerHTML = vdom.querySelector('.commerce-grid-footer').innerHTML;
            }
            else {
                // Probably an error, so show it in an info box.
                let content = vdom.querySelectorAll('body > *');
                let infoBox = document.createElement('div');
                infoBox.className = 'c ui negative message';
                for (let i = 0; i < content.length; i++) {
                    infoBox.appendChild(content[i]);
                }
                let cell = document.createElement('td');
                cell.setAttribute('colspan', grid.querySelectorAll('thead th').length);
                cell.appendChild(infoBox);
                let row = document.createElement('tr');
                row.classList.add('commerce-grid-row');
                row.appendChild(cell);
                rowContainer.appendChild(row);
            }

        }).catch((error) => {
            if (console) console.error('Error updating grid contents from remote url', error);
        });
    } // end submitToolbarForm
} // end Class
